import React, { useState } from "react";
import { BodyView, ButtonView, InputView, HeaderTitleView } from "../factory/ViewUtil";
import { NavBar } from "antd-mobile";
import { ToastClear, ToastContent, ToastLoading, ValidEmail } from "../factory/FactoryUtil";
import { RegisterSendCode } from "../../NetworkFactory";

const RegisterViewController = ({navpush, goback}) => {

    const [email, setEmail] = useState('') // 546444106@qq.com
    const [password, setPassword] = useState('') // 123456
    const [code, setCode] = useState('') // 123456

    const showError = () => {
        ToastContent(' Network or Unknown error')
    }
    const goNext = () => {
        if(email.length < 3) {
            ToastContent('Please enter your email address')
            return
        }
        if(!ValidEmail(email)) {
            ToastContent('Email is invalid')
            return
        }
        if(password.length < 6 || password.length > 20) {
            ToastContent('Valid password length 6-20')
            return
        }

        // # 邀请码
        /*
        if(code.length < 6 || code.length > 20) {
            ToastContent('Valid Invitation code length 6-20')
            return
        }*/

        // # 请求数据
        ToastLoading('Loading...')
        RegisterSendCode(email, code).then(response => {
            ToastClear()
            const {id, status} = response.data || {}
            if(id) {
                navpush('/code', true, {
                    id : id,
                    email : email,
                    password : password
                })
                return
            }
            if(status === -1) {
                ToastContent('The user has already registered')
                return
            }
            else if(status === -100) {
                ToastContent('Invalid invitation code')
                return
            }
            showError()
        }).catch((error) => {
            let {status = -1} = error || {}
            if(status === 509) {
                ToastContent('Access too fast')
                return
            }
            ToastClear()
            showError()
        })
    }

    return(
        <>
            <NavBar onBack = {goback}></NavBar>
            <BodyView>
                <HeaderTitleView>Register login account</HeaderTitleView>
                <InputView value={email} onChange={val => {setEmail(val)}} title='Your Email' clearable/>
                <div style={{height : '20px'}}></div>
                <InputView value={password} onChange={val => {setPassword(val)}} title='Your Password' type="password" clearable/>
                <div style={{height : '20px'}}></div>
                <InputView value={code} onChange={val => {setCode(val)}} title='Invitation Code' clearable/>
                <ButtonView onClick={goNext} style={{ width : '100%', marginTop : '20px'}}>Signup</ButtonView>
            </BodyView>
        </>
    )
}
export default React.memo(RegisterViewController)